import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/context/LanguageContext";
import { carDetailsLabels } from "@/i18n";

interface GuestLockedSectionProps {
  locked?: boolean;
  onLoginRequired?: () => void;
  children: React.ReactNode;
  className?: string;
}

/** Blurs content and shows login CTA — no sensitive data should be passed as children when locked. */
export const GuestLockedSection = ({
  locked = false,
  onLoginRequired,
  children,
  className = "",
}: GuestLockedSectionProps) => {
  const { language } = useLanguage();
  const guestLabels = carDetailsLabels(language).guest;

  if (!locked) {
    return <>{children}</>;
  }

  return (
    <div className={`relative ${className}`}>
      <div
        className="blur-md pointer-events-none select-none max-h-48 overflow-hidden"
        aria-hidden
      >
        {children}
      </div>
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-background/50 backdrop-blur-[2px] rounded-lg p-4 text-center">
        <Lock className="h-8 w-8 text-muted-foreground" />
        <p className="text-sm text-muted-foreground max-w-xs">
          {guestLabels.lockedSection}
        </p>
        <Button type="button" size="sm" onClick={onLoginRequired}>
          {guestLabels.loginCta}
        </Button>
      </div>
    </div>
  );
};
